/*eslint-disable */

import 'cropperjs/dist/cropper.css';

import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import VueCropper from 'vue-cropperjs';
import {bus} from '@/main';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
Vue.component('multiselect', Multiselect)
export default {
  name: 'group-create-popup',
  components: {Multiselect,VueCropper},
  props: [],
  data () {
    return {
      submitted:false,
      userList:{},
      userListResults:[], 
      options:[],
      topic:'',
      sentUserData:[],
      users:[],
      uploadAttachmentName:'',
      file:null,
      imgSrc:'',
      cropImg:'',
      cropedImg:''
    }
  },
  computed: {

  },
  mounted () {
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
      this.sentUserData.push(localStorage.getItem('LoginedUserID'))
    }
    // this.getAllUserListMethod()
  },
  methods: {
    handleAttachmentUpload(e) {
      const file = e.target.files[0];
      this.uploadAttachmentName = file.name;
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    getGroupRoomListAgain(){
      this.$store.dispatch('getChatRoomPinnedListFun').then((res) => {
        this.$store.dispatch('getAllLeftChatListDetailsFun')
      })
    },
    getAllUserListMethod() {
     this.$store.dispatch('getAllUserListsFun').then((res) => {
       this.userList = res.data.data
       if(this.userList != undefined){
         this.userListResults = this.userList
         for(var i = 0; i < this.userListResults.length; i++){
           this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
         }
       }
     }).catch((err)=>{})
    },
    cropImage(){
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      let cropperImg = this.cropImg;
      this.cropedImg = cropperImg.replace(/^data:image\/(png|jpg);base64,/, "")
      this.cancelCropCloseMethod()
    },
    cancelCropMethod(){
      setTimeout(()=>{
        this.imgSrc = '';
        this.cropedImg = ''
        this.uploadAttachmentName = ''
        this.$refs.cropper.reset();
      },10)
    },
    cancelCropCloseMethod(){
      setTimeout(()=>{
        this.imgSrc = '';
        this.$refs.cropper.reset();
      },10)
    },
    createGroupChatBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          for(var i = 0; i < this.users.length; i++){
            this.sentUserData.push(this.users[i].id)
          }
          var data = {
            name:this.topic,
            is_support_chat:false,
            is_group_chat:true,
            users:this.sentUserData
          }
          this.$store.dispatch('chatRoomCreatedFun', data)
            .then((res) => { 
              if(this.cropedImg != ''){
                var formData = new FormData();
                formData.append('group_image', this.file);
                let dataFile = {
                  "group_image": this.cropedImg,
                  "filename": this.uploadAttachmentName,
                }
                this.$store.dispatch('updateGroupChatDetailsFun', {data:{data:dataFile,id:res.data.data.id}}).then((res) => {
                  this.cropedImg = ''
                  toast.success(res.data.msg);
                  this.getGroupRoomListAgain()
                  this.createGroupPopupDisabledFun()
                  this.submitted =  false
                }).catch((err)=>{
                  this.submitted =  false
                  toast.error(err.data.msg);
                })
              }else{
                toast.success(res.data.msg);
                this.getGroupRoomListAgain()
                this.createGroupPopupDisabledFun()
                this.submitted =  false
              } 
            }).catch((err) => {
              toast.error(err.data.msg);
              this.submitted =  false
            })
          return;
        }
      })
    },
    createGroupPopupDisabledFun(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('createGroupPopupBus', false);
    }
  }
}